import React, { FC, memo } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import {
  warrantyTextStyles,
  warrantyViewStyles
} from 'src/views/transactions/TransactionPDF/styles';
import { NewBranchData, TemplateDetails } from 'src/types';

const styles = StyleSheet.create({
  root: {
    marginTop: 20
  },
  firstColumn: {
    ...warrantyViewStyles.flex2,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  firstColumnValue: {
    ...warrantyViewStyles.flex1,
    color: '#2B3445'
  },
  secondColumn: {
    marginLeft: 6,
    textAlign: 'right'
  },
  secondColumnValue: {
    marginHorizontal: 5,
    color: '#2B3445'
  },
  secondRow: {
    marginTop: 4
  }
});

interface Props {
  branchInfo?: NewBranchData;
  quotationData?: TemplateDetails;
}

const component: FC<Props> = ({ quotationData, branchInfo }) => {
  return (
    <View style={styles.root}>
      <View
        style={[warrantyViewStyles.row, { justifyContent: 'space-between' }]}
      >
        <View style={styles.firstColumn}>
          <Text style={[warrantyTextStyles.openSansBold, { color: '#2B3445' }]}>
            To:
          </Text>
          <Text
            style={[
              warrantyTextStyles.openSansRegular,
              styles.firstColumnValue
            ]}
          >
            {' '}
            {quotationData?.raw_name ?? 'N/A'}
          </Text>
        </View>

        <Text style={styles.secondColumn}>
          <Text style={warrantyTextStyles.openSansBold}>Branch:</Text>
          <Text
            style={[
              warrantyTextStyles.openSansRegular,
              styles.secondColumnValue
            ]}
          >
            {' '}
            {branchInfo?.branch_name ?? 'N/A'}
          </Text>
        </Text>
      </View>
    </View>
  );
};

export const ViewQuotationBuildInfo = memo(component);
